import React from 'react';
import './header.css';
import CTA from './CTA';
import portfolioConfig from '../../config/portfolioConfig';

const Header = () => {
  const { personal, heroHighlights, stackGroups } = portfolioConfig;
  const marqueeItems = stackGroups.flatMap((group) => group.items).slice(0, 9);

  return (
    <header id="home" className="hero-section">
      <div className="container hero-section__container">
        <div className="hero-section__content">
          <p className="section-eyebrow">{personal.subtitle}</p>
          <h1 className="hero-section__title">{personal.name}</h1>
          <p className="hero-section__lead">{personal.tagline}</p>
          <p className="hero-section__intro">{personal.intro}</p>

          <div className="hero-section__meta">
            <span>{personal.role}</span>
            <span>{personal.location}</span>
            <span>{personal.availability}</span>
          </div>

          <CTA />
        </div>

        <div className="hero-section__aside">
          <article className="hero-portrait panel">
            <div className="hero-portrait__image-wrap">
              <img
                src={personal.profileImage}
                alt={personal.name}
                className="hero-portrait__image"
              />
            </div>
            <div className="hero-portrait__content">
              <p className="hero-portrait__label">Currently focused on</p>
              <h2>Interfaces with stronger taste and cleaner structure.</h2>
              <p>
                The refreshed layout leans into typography, contrast, and real project context
                instead of glass layers and floating decoration.
              </p>
            </div>
          </article>

          <div className="hero-highlights">
            {heroHighlights.map((highlight) => (
              <article key={highlight.label} className="hero-highlight panel">
                <p className="hero-highlight__value">{highlight.value}</p>
                <h3>{highlight.label}</h3>
                <p>{highlight.note}</p>
              </article>
            ))}
          </div>
        </div>
      </div>

      <div className="hero-marquee" aria-label="Tooling highlights">
        <div className="hero-marquee__track">
          {[...marqueeItems, ...marqueeItems].map((item, index) => (
            <span key={`${item}-${index}`}>{item}</span>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
